import { render, staticRenderFns } from "./GraphCanvas2D.vue?vue&type=template&id=5a00b77e&"
import script from "./GraphCanvas2D.vue?vue&type=script&lang=js&"
export * from "./GraphCanvas2D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports